const session = Object.create(
  {},
  {
    stored: {
      configurable: true,
      set(value) {
        sessionStorage.setItem('queryParams', JSON.stringify(value));
      },
      get() {
        const item = JSON.parse(sessionStorage.getItem('queryParams'));
        return item || null;
      },
    },
  }
);

const fillParameters = (key, searchParams, defaultValue) => {
  const value = searchParams.get(key);
  if (value) {
    return value;
  }
  const { stored } = session;
  return stored ? stored[key] : defaultValue;
};

const useQueryChecker = () => {
  const queryParams = {
    code: null,
    hmac: null,
    shop: 'dev',
    timestamp: null,
    state: null,
  };

  const searchParams = new URLSearchParams(window.location.search);

  Object.keys(queryParams).forEach((key) => {
    const defaultValue = queryParams[key];
    queryParams[key] = fillParameters(key, searchParams, defaultValue);
  });

  session.stored = queryParams;

  return {
    queryParams,
  };
};
export default useQueryChecker;
